import React from 'react';
import HeroCarousel from '../agencies/HeroCarousel';
import Agencies from './Agencies';

const Home = () => {
  return (
    <>
      
      <HeroCarousel />
      <Agencies />
      
    </>
  );
};

export default Home;
